import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=58879bfc&scoped=true&"
import script from "./Leaderboard.vue?vue&type=script&lang=js&"
export * from "./Leaderboard.vue?vue&type=script&lang=js&"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=58879bfc&scoped=true&lang=scss&"
import style1 from "./Leaderboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58879bfc",
  null
  
)

export default component.exports